import { render } from "./TopNav.vue?vue&type=template&id=40734687&scoped=true"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"

import "./TopNav.vue?vue&type=style&index=0&id=40734687&scoped=true&lang=css"

import exportComponent from "D:\\AppDev\\__\\_goblinbank\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40734687"]])

export default __exports__